import { LanguageSelector } from '../../app/LanguageSelector';

export default function HeaderAuth() {
  return (
    <header className="container flex items-center justify-end pt-8 md:justify-between">
      <img src="/images/logos/hero-Logo.svg" alt="Hero logo" className="hidden md:!block h-10" />

      <LanguageSelector />
    </header>
  );
}
